import React from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import CDInput from 'components/cd-input'
import TextArea from 'components/text-area'
import CDButton from 'components/cd-button'
import NativeSelect from '../components/native-select'
import { couponsApi } from '../restaurant.api'
import { useDeals } from './deals.context'

const DISCOUNT_TYPE_OPTIONS = [
  { value: 'percentage', label: 'Percentage' },
  { value: 'fixed', label: 'Fixed' },
]

const STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
]

const validationSchema = Yup.object({
  code: Yup.string().required('Coupon code is required'),
  discountValue: Yup.number()
    .typeError('Discount value must be a number')
    .min(0, 'Discount cannot be negative')
    .required('Discount value is required'),
})

const toInitialValues = (coupon) => ({
  code: coupon?.code || '',
  description: coupon?.description || '',
  discountType: coupon?.discountType || 'percentage',
  discountValue: coupon?.discountValue ?? '',
  maxUses: coupon?.maxUses ?? '',
  status: coupon?.status || 'active',
})

function CouponForm({ coupon, onClose }) {
  const { refresh } = useDeals()
  const isEditing = !!coupon?._id

  const handleSubmit = async (values, { setSubmitting }) => {
    const payload = {
      ...values,
      code: (values.code || '').toUpperCase().trim(),
      discountValue: Number(values.discountValue),
      maxUses: values.maxUses === '' ? undefined : Number(values.maxUses),
    }

    const { response } = isEditing
      ? await couponsApi.update(coupon._id, payload)
      : await couponsApi.create(payload)

    setSubmitting(false)
    if (response?.success) {
      await refresh()
      onClose()
    }
  }

  return (
    <Formik
      initialValues={toInitialValues(coupon)}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formik) => (
        <Form className='tw-flex tw-flex-col tw-gap-4'>
          <CDInput name='code' label='Code' required placeholder='SAVE10' />
          <TextArea name='description' label='Description' />
          <NativeSelect
            name='discountType'
            label='Discount type'
            options={DISCOUNT_TYPE_OPTIONS}
          />
          <CDInput
            name='discountValue'
            label='Discount value'
            type='number'
            required
          />
          <CDInput name='maxUses' label='Max uses (blank = unlimited)' type='number' />
          <NativeSelect name='status' label='Status' options={STATUS_OPTIONS} />

          <div className='tw-flex tw-gap-3 tw-mt-2'>
            <CDButton
              type='submit'
              processing={formik.isSubmitting}
              label={isEditing ? 'Save changes' : 'Create coupon'}
            />
            <button
              type='button'
              onClick={onClose}
              className='tw-px-[24px] tw-py-[8px] tw-rounded-[6px] tw-border tw-border-gray-300 tw-text-gray-600 tw-text-regular'
            >
              Cancel
            </button>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default CouponForm
